const InputLabel = theme => {
  return {
    MuiInputLabel: {
      variants: [{
        props: {
          shrink: false
        },
        style: {
          top: -8
        }
      }],
      styleOverrides: {
        root: {
          color: theme.palette.text.primary
        }
      }
    }
  };
};

export { InputLabel };
